module.exports = __webpack_public_path__ + "static/simple-bubble-ea1387ec712fb2833efea4c8966bdd62.png";